package com.example.monetix.ui.screens

import dev.gitlive.firebase.auth.FirebaseAuth
import kotlinx.coroutines.await
import kotlin.js.Promise

// --- 🚀 INTEROP JS ROBUSTO ---
@JsModule("firebase/auth")
@JsNonModule
external object FirebaseAuthModule {
    @JsName("GoogleAuthProvider")
    class GoogleAuthProvider

    @JsName("getAuth")
    fun getAuth(): dynamic

    @JsName("signInWithPopup")
    fun signInWithPopup(auth: dynamic, provider: dynamic): Promise<dynamic>
}

actual suspend fun signInWithGoogleCommon(auth: FirebaseAuth) {
    try {
        println("🚀 Inizio processo login Google...")

        // 1. Creiamo il provider usando il modulo esplicito
        val provider = js("new (require('firebase/auth').GoogleAuthProvider)()")

        // 2. Recuperiamo l'istanza Auth nativa
        val nativeAuth = js("require('firebase/auth').getAuth()")

        // 3. Lanciamo il popup
        val signInWithPopup = js("require('firebase/auth').signInWithPopup")

        println("📱 Apertura Popup Google...")
        (signInWithPopup(nativeAuth, provider) as Promise<dynamic>).await()

        println("✅ Login con Google completato!")

    } catch (e: Exception) {
        println("❌ Errore Google Login (Web): ${e.message}")
        // Se l'errore dice "auth/unauthorized-domain", devi aggiungere
        // monetix.pages.dev nei domini autorizzati su Firebase Console!
        throw e
    }
}